// export const baseURL = "http://127.0.0.1:8000/api"
// export const ProxyUrl =  'https://cors-anywhere.herokuapp.com/'
export const S3BaseUrl = "https://grandpdf.s3.eu-central-1.amazonaws.com/"
export const baseURL =   'https://api.grandtransfer.io/api'
// export const baseURL = "https://digimonk.live/grandpdf_backend/public/api";
// export const baseURL = "http://192.168.0.173/Hemant-sir/grand_pdf/public/api";
export const ProxyUrl = 'https://grandpdf.b-cdn.net'
// export const ProxyUrl =  ''
